module.exports = __webpack_public_path__ + "img/main_pic1.28229a1a.jpg";